import React from "react"
import { func, string } from "prop-types";
import styled from "styled-components"


const _Wallet = styled.button`
    color: ${({ theme }) => theme.walletTextColor};
    background-color: ${({ theme }) => theme.walletBackgroundColor};
    box-shadow: ${({ theme }) => theme.newPanelShadow};
    border-radius: 0.7em;
    font-size: 0.7em;
    margin: 0, auto;
    padding: 0.6em;
    text-align: center;
    align-self: center;
    justify-content: center;
    cursor: pointer;
    border: 0.15em solid ${({ theme, isValid }) => isValid ? theme.walletBorderColor : theme.walletNotConnectedBorderColor};
`;

function Wallet(props) {
	return (
		<_Wallet onClick={props.connectionHandler} isValid={props.isConnectedToWeb3}>
			{
				props.isMyAccountConnected ?
				props.account.slice(0, 6) + "..." + props.account.slice(props.account.length-5, props.account.length-1)
				:
				<>
					{
						props.isConnectedToWeb3 ? "Connect to a wallet" : "Connect to web3"
					}
				</>
			}
		</_Wallet>
	)
}
export default Wallet;